import * as siteVariables from './siteVariables';
import * as componentVariables from './componentVariables';
import * as componentStyles from './componentStyles';
export default {
    siteVariables: siteVariables,
    componentVariables: componentVariables,
    componentStyles: componentStyles,
};
